<template>
  <div>
    <e-learning-editor
      @submit="submit"
      :eLearning="eLearning"
    ></e-learning-editor>
  </div>
</template>

<script>
import ELearningEditor from "@/views/health-recommendation/HealthRecommendationEditor";

import axios from "axios";

export default {
  components: {
    ELearningEditor,
  },
  created() {
    this.fetchELearning();
  },
  data() {
    return {
      eLearning: null,
    };
  },
  methods: {
    async fetchELearning() {
      let loader = this.$loading.show();

      try {
        const response = await axios.get(
          `api/e-learning/${this.$route.params.eLearningId}`
        );

        this.eLearning = response.data;

        loader.hide();
      } catch (error) {
        loader.hide();

        console.log(error);
      }
    },
    async submit(data) {
      const { title, categoryId, content } = data;

      let loader = this.$loading.show();

      try {
        const response = await axios.put(
          `api/health-recommendation/${this.$route.params.eLearningId}`,
          {
            title,
            categoryId,
            content,
          }
        );

        this.$router.replace({
          name: "admin-e-learning-index",
          query: { ...this.$route.query, step: "step-2-3" },
        });

        loader.hide();
      } catch (error) {
        loader.hide();

        console.log(error);
      }
    },
  },
};
</script>